/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is each element's share of the total molar mass, calculated as the element's total mass divided by the molar mass. The percentages add up to 100%.`)
};

const es_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es la proporción de cada elemento respecto a la masa molar total, calculada como la masa total del elemento dividida entre la masa molar. Los porcentajes suman 100%.`)
};

const de_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist der Anteil jedes Elements an der gesamten molaren Masse, berechnet als Gesamtmasse des Elements geteilt durch die molare Masse. Die Prozentsätze addieren sich zu 100%.`)
};

const nl_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit is het aandeel van elk element in de totale molaire massa, berekend als de totale massa van het element gedeeld door de molaire massa. De percentages tellen op tot 100%.`)
};

const fr_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est la part de chaque élément dans la masse molaire totale, calculée comme la masse totale de l'élément divisée par la masse molaire. Les pourcentages totalisent 100 %.`)
};

const it_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È la quota di ciascun elemento sulla massa molare totale, calcolata come la massa totale dell'elemento divisa per la massa molare. Le percentuali sommano a 100%.`)
};

const pt_br2_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a participação de cada elemento na massa molar total, calculada como a massa total do elemento dividida pela massa molar. Os percentuais somam 100%.`)
};

const pt_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a fração de cada elemento na massa molar total, calculada como a massa total do elemento dividida pela massa molar. As percentagens somam 100%.`)
};

const ja_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モル質量全体に占める各元素の割合で、元素の総質量をモル質量で割って計算されます。パーセンテージの合計は100%になります。`)
};

const zh_mw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是每个元素占总摩尔质量的比例，计算方式为该元素的总质量除以摩尔质量。所有百分比之和为 100%。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_faq_a3", locale)
	if (locale === "en") return en_mw_faq_a3(inputs)
	if (locale === "es") return es_mw_faq_a3(inputs)
	if (locale === "de") return de_mw_faq_a3(inputs)
	if (locale === "nl") return nl_mw_faq_a3(inputs)
	if (locale === "fr") return fr_mw_faq_a3(inputs)
	if (locale === "it") return it_mw_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_mw_faq_a3(inputs)
	if (locale === "pt") return pt_mw_faq_a3(inputs)
	if (locale === "ja") return ja_mw_faq_a3(inputs)
	return zh_mw_faq_a3(inputs)
};